import { LOGS_URLS } from "../../services/apiConfig.js";
import { ACSIDENTITY_ERRORS } from "../../common/constants/ivrModule/acsConstants.js";
import apiClient from "../apiInstance.js";


export const getCallsInfo = async () => {
    try {
        const response = await apiClient.post(LOGS_URLS.GET_CALL_INFO);
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getBacklog = async () => {
    try {
        const response = await apiClient.get(LOGS_URLS.GET_BACKLOG);
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};